module.exports = __webpack_public_path__ + "static/media/fulande.b984c0a4.jpg";